import { render, staticRenderFns } from "./PackageAndCheck.vue?vue&type=template&id=89633444&scoped=true"
import script from "./PackageAndCheck.vue?vue&type=script&lang=js"
export * from "./PackageAndCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89633444",
  null
  
)

export default component.exports